import PropTypes from 'prop-types'

import Controls from '@aytm/app/stats/page/question-views/mn/Controls'
import ControlsComponents from '@aytm/app/stats/page/question-views/oe/components/ControlsComponents'

import mnStyle from '@aytm/app/stats/page/question-views/mn/Controls.module.scss'
import oeStyle from '@aytm/app/stats/page/question-views/oe/styles/Controls.module.scss'

const CommentsControls = ({ title, collapsed, onToggle, disabled, ...oeProps }) => (
  <>
    <Controls title={title} collapsed={collapsed} onToggle={onToggle} />
    {!collapsed && !disabled && (
      <div className={`${oeStyle.component} ${mnStyle.controls} p-fluid`}>
        <ControlsComponents disabled={disabled} {...oeProps} />
      </div>
    )}
  </>
)

CommentsControls.propTypes = {
  title: PropTypes.string,
  collapsed: PropTypes.bool,
  onToggle: PropTypes.func,
  model: PropTypes.object,
  data: PropTypes.object,
  features: PropTypes.object,
  disabled: PropTypes.bool,
  isVerbatimType: PropTypes.bool,
  isSurveyGuest: PropTypes.bool,
  onViewModeChange: PropTypes.func,
  onConfigChange: PropTypes.func,
  onExport: PropTypes.func
}

CommentsControls.displayName = 'CommentsControls'

export default CommentsControls
